import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import "./UserSelect.css"
import React, {useEffect, useState} from "react";
import RootState from "../../../redux/states/root.state";
import { CircularProgress, Pagination, Button, TextField, Radio, FormControlLabel, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Box, Typography, RadioGroup } from "@mui/material";
import { fetchDealerships } from "../../../redux/actions/dealership.actions";

interface UserSelectProps {
    setSelected: any;
    selected: any;
    current: any;
}

const DealershipSelect: React.FC<UserSelectProps> = ({ setSelected, selected, current }) => {
const dispatch: AppDispatch = useDispatch();
const {data:dealerships,meta,loading} = useSelector((state: RootState) => state.dealerships);
const [pageNumber, setPageNumber] = useState(1);
const [name, setName] = useState(``);
const [nameQuery, setNameQuery] = useState<any>(null);

useEffect(() => {
    setName(current?.name??'')
  }, [current]);

useEffect(() => {
    let query = `page=${pageNumber}`;
    if (nameQuery){
        query = query + `&name=${encodeURIComponent(nameQuery)}`
    }
    dispatch(fetchDealerships(query))
  }, [dispatch,pageNumber, nameQuery]);

  return (
    <>
    <div className="user-search-container">
        <TextField type="search" placeholder="Search name..." onChange={(e)=>setName(e.target.value)} defaultValue={name} size="small" fullWidth/>
        <Button type="button" variant="contained" onClick={()=>setNameQuery(name)} size="small">Search</Button>
    </div>

        { loading ?
            <div className="no-users"><CircularProgress size={"24px"}/></div>
        :
        dealerships.length>0 ? 
        <div className="select-container">
            <RadioGroup
                value={selected?.id || current?.id || ''}
                onChange={(e) => {
                    const dealership = dealerships.find(d => d.id === e.target.value);
                    if (dealership) setSelected(dealership);
                }}
            >
                <List 
                    dense
                    sx={{
                        maxHeight: 200,
                        overflow: 'auto',
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0,0,0,0.1)',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.3)',
                            borderRadius: '4px',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.5)',
                            },
                        },
                    }}
                >
                    {dealerships.map((dealership: any) => (
                        <ListItem key={dealership?.id} disablePadding>
                            <ListItemButton
                                onClick={() => setSelected(dealership)}
                                selected={selected ? selected?.id === dealership?.id : current?.id === dealership?.id}
                                sx={{ borderRadius: 1 }}
                            >
                                <ListItemIcon>
                                    <Radio value={dealership?.id} size="small"/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body2">
                                            {dealership?.name !== '' ? `${dealership?.id} ${dealership?.name}` : dealership?.id}
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </RadioGroup>
            {
            meta?.total_pages>1 &&
            <Pagination 
                count={meta?.total_pages} 
                size="small"
                onChange={(e,page)=>setPageNumber(page)}
                page={pageNumber}
                showLastButton 
                showFirstButton 
                disabled={meta?.total_pages===1}
            />
            }
        </div>
        :
        <div>No Dealerships Found.</div>
    }
    </>
  );
};

export default DealershipSelect;
